(function () {
  var directiveIdShow = "showonhoverparent";
  var directiveIdHide = "hideonhoverparent";
  angular
    .module("app")
    .directive(directiveIdShow,
      function () {
        return {
          restrict: "A",
          link: function (scope, element, attrs) {
            element.addClass("parentHoverHide");
            var elemToBind = element.parent();
            if (attrs.showonhoverparent !== "") {
              elemToBind = element.closest(attrs.showonhoverparent);
            }
            elemToBind.bind("mouseenter", function () {
              element.removeClass("parentHoverHide");
              element.addClass("parentHoverShow");
            });
            elemToBind.bind("mouseleave", function () {
              element.removeClass("parentHoverShow");
              element.addClass("parentHoverHide");
            });
          }
        };
      }
    );

  angular
    .module("app")
    .directive(directiveIdHide,
      function () {
        return {
          restrict: "A",
          link: function (scope, element, attrs) {
            element.addClass("parentHoverShow")

            var elemToBind = element.parent();

            if (attrs.hideonhoverparent !== "") {
              elemToBind = element.closest(attrs.hideonhoverparent);
            }

            elemToBind.bind("mouseenter", function () {
              element.removeClass("parentHoverHide");
              element.addClass("parentHoverShow");
            });
            elemToBind.bind("mouseleave", function () {
              element.removeClass("parentHoverShow");
              element.addClass("parentHoverHide");
            });
          }
        };
      }
    );

})();




// WEBPACK FOOTER //
// ./app/components/hover.directive.js